import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { filter, map, take } from 'rxjs/operators';
import { BaseCoreState, baseInquiryActions, baseInquirySelectors, BaseInquiryService, InquiryResponse } from 'base';

@Injectable()
export class BaseCustomerInquiryService {
  constructor(
    private store: Store<BaseCoreState>,
    public baseInquiryService: BaseInquiryService,
    private readonly router: Router
  ) {}

  getInquiry(inquiryId: number) {
    this.store.dispatch(baseInquiryActions.loadCustomerInquiry({ payload: inquiryId }));
    return this.store.select(baseInquirySelectors.getCustomerInquiry).pipe(
      filter((state) => !!state.ok),
      map((state) => state.data as InquiryResponse),
      take(1)
    );
  }

  openShiftViewPage(inquiry: InquiryResponse, inquiryId?: number) {
    this.createDataForShiftView(inquiry);

    if (inquiryId) {
      this.router.navigate(['inquiries', 'shift-plan', inquiryId]);
    } else {
      this.router.navigate(['inquiries/shift-plan']);
    }
  }

  createDataForShiftView(inquiry: InquiryResponse) {
    if (inquiry.dates) {
      this.store.dispatch(
        baseInquiryActions.openInquiryInEditMode({
          payload: {
            inquiry,
            similarInquiriesPayload: {
              statuses: ['2'],
              includeDates: true,
              current: true,
              mainQualifications: [inquiry.mainQualification?.id as number],
              departments: [inquiry.customerDepartment?.id as number],
            },
          },
        })
      );
    }
  }

  defineIsShiftTypesMixed(inquiry: InquiryResponse) {
    if (inquiry.dates?.length) {
      if (inquiry.dates?.length === 1) {
        return false;
      }

      let isShiftsMixed = false;

      for (let index = 1; index < inquiry.dates.length; index++) {
        const item = inquiry.dates[index];
        isShiftsMixed = !this.baseInquiryService.isTwoDatesAreSimilar(item, inquiry.dates[index - 1]);
        if (isShiftsMixed) {
          break;
        }
      }

      return isShiftsMixed;
    }

    return false;
  }
}
